import * as React from 'react';

const ApplicationsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#0092E4" />
    <path
      d="M17.6666 7.66602H10.9999C10.0833 7.66602 9.34159 8.41602 9.34159 9.33268L9.33325 22.666C9.33325 23.5827 10.0749 24.3327 10.9916 24.3327H20.9999C21.9166 24.3327 22.6666 23.5827 22.6666 22.666V12.666L17.6666 7.66602ZM20.9999 22.666H10.9999V9.33268H16.8333V13.4993H20.9999V22.666ZM13.3499 16.8743L12.1666 18.0493L15.1166 20.9993L19.8333 16.2827L18.6583 15.1077L15.1249 18.641L13.3499 16.8743Z"
      fill="white"
    />
  </svg>
);

export default ApplicationsIcon;
